import React, { useEffect, useState } from 'react';
import { Router, Route, Switch, Link, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { LinkAdapterProvider, LinkAdapter } from '@gaiads/telia-react-component-library';
import { useDispatch, useSelector } from 'react-redux';

import Header from './Header/Header';
import SalesChannelsScreen from '../SalesChannels/SalesChannels';
import { fetchLocales, selectAllLocales, selectLocaleLoading, setLocale } from '../../store/locales';
import ProductScreen from '../ProductForm/ProductForm';
import ProductsView from '../Products/Products';
import BundleScreen from '../BundleForm/BundleForm';
import { Loading } from '../../utils/store';
import SalesChannelForm from '../SalesChannelForm/SalesChannelForm';
import AdminSettings from '../AdminSettings/AdminSettings';
import BundlesView from '../Bundles/BundlesView';
import SalesChannelBundlesView from '../SalesChannelBundles/SalesChannelBundlesView';
import ProductMainScreen from '../ProductMainScreen/ProductMainScreen';
import { fetchAdminCountries } from '../../store/adminCountries';
import { fetchSalesChannels } from '../../store/salesChannels';

import './App.scss';
import { fetchFeatureFlags, selectFeatureFlagsLoading } from '../../store/featureFlags';

export const history = createBrowserHistory();

function App() {
  const featureFlagsLoading = useSelector(selectFeatureFlagsLoading);
  const localeLoading = useSelector(selectLocaleLoading);
  const locales = useSelector(selectAllLocales);
  const [isReady, setIsReady] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFeatureFlags());
    dispatch(fetchLocales());
    dispatch(fetchAdminCountries());
    dispatch(fetchSalesChannels());
  }, [dispatch]);

  useEffect(() => {
    if (featureFlagsLoading === Loading.SUCCEEDED && localeLoading === Loading.SUCCEEDED) {
      if (locales[0]) {
        dispatch(setLocale(locales[0].id));
      }
      setIsReady(true);
    } else {
      setIsReady(false);
    }
    // TODO: show error on fail
  }, [dispatch, featureFlagsLoading, localeLoading, locales]);

  const RouterLinkAdapter: LinkAdapter = ({ to, children, className }) => (
    <Link to={to as string} className={className}>
      {children}
    </Link>
  );

  if (!isReady) {
    return <></>;
  } else
    return (
      <div>
        <Router history={history}>
          {/* @ts-expect-error type { children: Element;   linkAdapter: LinkAdapter; } is not assignable to type IntrinsicAttributes & LinkAdapterProviderProps */}
          <LinkAdapterProvider linkAdapter={RouterLinkAdapter}>
            <div className="telia-react-typography telia-react-typography__helvetica">
              <Header />
              <div>
                <main>
                  <Switch>
                    <Route path="/saleschannel/:salesChannelUuid/bundles" component={SalesChannelBundlesView} />
                    <Route path="/saleschannel/:salesChannelUuid" component={SalesChannelForm} />
                    <Route path="/saleschannel" component={SalesChannelForm} />
                    <Route path="/product/:productId/main/:countryCode" component={ProductMainScreen} />
                    <Route path="/product/:productId/main" component={ProductMainScreen} />
                    <Route path="/product/:productId/details" component={ProductScreen} />
                    <Redirect from="/product/:productId" to="/product/:productId/main" />
                    <Route path="/product" component={ProductScreen} />
                    <Route path="/bundle/:bundleId" component={BundleScreen} />
                    <Route path="/bundle" component={BundleScreen} />
                    <Route path="/adminsettings" component={AdminSettings} />
                    <Route path="/saleschannels" component={SalesChannelsScreen} exact />
                    <Route path="/bundles" component={BundlesView} exact />
                    <Route path="/" component={ProductsView} />
                  </Switch>
                </main>
              </div>
            </div>
          </LinkAdapterProvider>
        </Router>
      </div>
    );
}

export default App;
